import * as React from 'react';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import TextField from '../../ui/TextField/TextField';
import styles from './TemplateModal.styl';
class TemplateModal extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                title: this.props.isSave ? this.props.isSave.value : ''
            }
        });
        Object.defineProperty(this, "onChangeTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.setState({ title: value });
            }
        });
        Object.defineProperty(this, "onAcceptClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { title } = this.state;
                this.props.onAccept(title);
            }
        });
    }
    render() {
        const { onDecline, title, text, isSave, confirmName, declineName } = this.props;
        return (React.createElement("div", { className: styles.confirmModal },
            React.createElement("div", { className: styles.content },
                React.createElement("h4", { className: styles.heading }, title),
                React.createElement("p", { className: styles.text }, text)),
            isSave && React.createElement(TextField, { onChange: this.onChangeTitle, value: this.state.title, name: 'popUp', className: styles.textField }),
            React.createElement("div", { className: styles.controls },
                React.createElement(Button, { className: styles.confirm, variant: 'filled', onClick: this.onAcceptClick }, confirmName),
                React.createElement(Button, { className: styles.decline, variant: 'tonal', onClick: onDecline }, declineName))));
    }
}
Object.defineProperty(TemplateModal, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        onAccept: () => { },
        onDecline: () => { },
        confirmName: 'YES',
        declineName: 'NO'
    }
});
export default TemplateModal;
